/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface PrivacyPolicyPdfControllerGetPdfV1$Params {
  id: number;
  sprache: string;
}

export function privacyPolicyPdfControllerGetPdfV1(http: HttpClient, rootUrl: string, params: PrivacyPolicyPdfControllerGetPdfV1$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
  const rb = new RequestBuilder(rootUrl, privacyPolicyPdfControllerGetPdfV1.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.path('sprache', params.sprache, {});
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: 'application/pdf', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Blob>;
    })
  );
}

privacyPolicyPdfControllerGetPdfV1.PATH = '/v1/privacy-policies/{id}/pdf/{sprache}';
